// German/Dutch name particles belong to the LAST name ("Reinhard von der Wehl" → last: "von der Wehl")
const PARTICLES = ['von', 'van', 'zu', 'zur', 'zum', 'vom', 'der', 'den', 'dem', 'de', 'da', 'di', 'del', 'della', 'ter', 'ten'];

export const splitFullName = (name) => {
  const tokens = (name || '').trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return { first: '', last: '' };
  if (tokens.length === 1) return { first: '', last: tokens[0] };
  let idx = tokens.length - 1;
  for (let i = 1; i < tokens.length - 1; i++) {
    if (PARTICLES.includes(tokens[i].toLowerCase())) { idx = i; break; }
  }
  return { first: tokens.slice(0, idx).join(' '), last: tokens.slice(idx).join(' ') };
};
